import { render } from "./NumberFourIcon.vue?vue&type=template&id=79866db6"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/NumberFourIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79866db6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79866db6', __exports__)) {
    api.reload('79866db6', __exports__)
  }
  
  module.hot.accept("./NumberFourIcon.vue?vue&type=template&id=79866db6", () => {
    api.rerender('79866db6', render)
  })

}


export default __exports__